/* eslint-disable import/first */

//region 1. Platform Libraries */
const ipaddr = require('ipaddr.js');
//endregion

//region 2. Project Libraries */
import { isWithinValidPublicIpRange } from '../Utils';
import { logger } from '../DataAPI';
//endregion

export default function checkPublicIP(req, res, next) {
    const ip = req.body.publicIp;
    const log = (lvl, msg) => logger.log(lvl, msg, { tags: 'checkPublicIP' });
    if (!ip) {
        const message = 'No Public IP';
        log('error', message);
        res.status(400).send(message);
        return;
    }
    if (!ipaddr.isValid(ip)) {
        const message = `Malformed Public IP ${ip}`;
        log('error', message);
        res.status(400).send(message);
        return;
    }
    if (!isWithinValidPublicIpRange(ip)) {
        const message = `Public IP in Invalid Range ${ip}`;
        log('error', message);
        res.status(400).send(message);
        return;
    }
    if (next) {
        next();
    }
}
